import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';

const LLAMA_PRICES_URL = 'https://coins.llama.fi/prices/current';

type TokenPrices = Record<string, number>;

export const useTokenPrices = (addresses: string[]) => {
  const uniqueAddresses = useMemo(() => [...new Set(addresses)], [addresses]);
  const coins = useMemo(
    () => uniqueAddresses.map((address) => `ethereum:${address}`).join(','),
    [uniqueAddresses],
  );

  return useQuery<TokenPrices>({
    queryKey: ['tokenPrices', coins],
    queryFn: async () => {
      const res = await fetch(`${LLAMA_PRICES_URL}/${coins}`);
      const data = await res.json();

      const result: TokenPrices = {};
      for (const address of uniqueAddresses) {
        const key = `ethereum:${address.toLowerCase()}`;
        const found = Object.entries(data.coins ?? {}).find(([k]) => k.toLowerCase() === key);
        const price = (found?.[1] as { price: number } | undefined)?.price;
        if (price != null && price > 0) {
          result[address.toLowerCase()] = price;
        }
      }

      return result;
    },
    staleTime: 60_000,
    refetchInterval: 60_000,
    placeholderData: keepPreviousData,
    enabled: uniqueAddresses.length > 0,
  });
};
